import React from "react";

import { NotesPanel } from "../../../note/index.js";
import { PreviewDialogTemplate } from "../../../shared/templates/index.js";

export default React.memo(({ actions = {} }) => (
  <PreviewDialogTemplate
    actions={actions}
    title="notes"
    maxWidth="xs"
    breakpointPixels={450}
    content={<NotesPanel bgFrom="MuiDialog" overrideSm />}
  />
));
